var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14.5","cy":"14.5","r":"13.5","fill":"#EFF1FF","stroke":"#40196D","strokeWidth":"0.5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.5461 15.0841V20.8648H15.4162V15.1115H17.3755L17.8499 12.713H15.4368V10.9536C15.4368 10.7106 15.5691 10.3859 15.971 10.3859H17.3657V7.94336H14.7614C13.8625 7.94336 12.5362 9.02755 12.5362 10.1804V12.6447H11.0303V15.074L12.5461 15.0841Z","fill":"#40196D","key":1})]);
}

FacebookInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
